import React, {
  useState,
  createContext,
  useContext,
  useCallback,
  useEffect,
  useMemo,
} from 'react';
import { Snackbar, Slide } from '@material-ui/core';
import { css } from '@emotion/core';

export const SnackBarContext = createContext({ alert: [], open: false });

export function SnackBarProvider({ children }) {
  const [alerts, setAlerts] = useState([]);
  let _ID = 0;
  const activeAlertIds = alerts.join(',');
  const deleteAlert = id => setAlerts(a => a.filter(m => m.id !== id));
  const handleAlert = useCallback((content, bgcolor = 'green') => {
    setAlerts(a => [{ content, id: _ID++, bgcolor }, ...a]);
    deleteAlert();
  }, []);

  useEffect(() => {
    if (activeAlertIds.length > 0) {
      const timer = setTimeout(
        () => setAlerts(a => a.slice(0, a.length - 1)),
        4000,
      );
      return () => clearTimeout(timer);
    }
  }, [activeAlertIds]);

  const value = useMemo(() => handleAlert, [handleAlert]);
  return (
    <SnackBarContext.Provider value={value}>
      {alerts.map(alert => (
        <Snackbar
          key={alert.id}
          open
          css={css`
            .MuiSnackbarContent-root {
              background-color: ${alert.bgcolor} !important;
            }
          `}
          TransitionComponent={Slide}
          message={alert.content}
        />
      ))}
      {children}
    </SnackBarContext.Provider>
  );
}

export const useSnackBars = () => useContext(SnackBarContext);
